/***************** PAGE LOADER *****************/
var $domain = window.location.href.split("/"),
    $domain = $domain[0] + "//" + $domain[2],
    $internalLinks = $("a[href^='" + $domain + "']"),
    $pageloaderActive = 0,
    $pageloaderStarted = 0,
    $_window = $(window),
    $_body = $("body"),
    $_html = $("html"),
    $_urlParams = '',
    $_gaActive = 1,
    $_debug = 0,
    $_forPopstate = 1,
    $current_page = "",
    $_loaderState = "finish",
    $_loaderTimeout = 0,
    _loaderTimer = 1500,
    url_old = '',
    newMetas = ['[rel="shortlink"]', '[rel="canonical"]', '[property="og:title"]', '[property="og:url"]', '[property="og:image"]', '[name="twitter:title"]', '[name="twitter:image"]', '[name="description"]'],
    globalAllowClick = 0; //When loading do not allow clicks by user ( onStartPage revers to true);    

function loadPages(newContent, pageTransition, elem) {
    var $currentPage = $(".page-main.page-current"),
        $nextContent = $(".page-main.page-next"); // can't be global

    if (!pageTransition) pageTransition = "default";

    if (pageTransition == "default") { //animation by default
        if ($_debug) console.log("page: default");

        loadingTransition("start", function () {
            //$nextContent.load(newContent, function (response, status, xhr) {
            $.ajax({
                type: 'GET', //or GET
                dataType: "html", //or html, text
                url: newContent,
                success: function (response) {
                    if (!response) {
                        window.location = newContent;
                        return;
                    }

                    var newDoc = (new DOMParser()).parseFromString(response, "text/html");
                    var newDocBody = $(newDoc.body);

                    var metatags = $(newDoc.head);
                    var bodyClass = newDocBody.attr("class");
                    var headerClass = $("#masthead", newDocBody).attr("class");
                    var menuBtnClass = $(".mobile-menu-button", newDocBody).attr("class");
                    var content = $(".page-main", newDocBody).contents();

                    $_body.attr('class', bodyClass);
                    $("#masthead").attr('class', headerClass);
                    $(".mobile-menu-button").attr('class', menuBtnClass);
                    $nextContent.html(content);

                    // ANIMATION GOES HERE
                    var delay_time = 500;

                    //$.doTimeout(1e3 * delay_time, function() {
                    $.doTimeout(delay_time, function () {
                        TweenLite.to($currentPage, 0, {
                            opacity: 0,
                            onComplete: function () {
                                handleMetas(metatags, 0);
                                clearPagesAfterloading(0);

                                loadingTransition("finish", function () {
                                    document.dispatchEvent(new Event('DOMContentLoaded'));
                                    window.dispatchEvent(new Event('load'));
                                    setTimeout(function(){
                                        UNCODE.initHeader();
                                        UNCODE.init();
                                    }, 1200);

                                });
                            }
                        });
                    });
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    window.location = newContent;
                    return;
                },
                cache: false
            });
        });
    }
}

function loadingTransition(state, f) {
    var $loading = $(".loaderTransition");

    if (state == "start") {
        if ($('body').hasClass('off-opened')){
            $('.loaderTransition').addClass('light'); 
        }
        TweenLite.to('.loaderTransition', 0.5, {
            x: '70%',
            force3D: true,
            onComplete: function(){
                TweenLite.to('.loaderTransition', 0.5, {
                    x: '0%',
                    force3D: true
                });
            }
        });
        // TweenLite.to($loading, _loaderTimer, {
        //     x: 0,
        //     ease: Expo.easeOut,
        //     onComplete: function () {
        //         $loading.addClass('loading');

        //         if ($_debug) console.log("loader started completed");
        //         if (typeof f == "function") f();
        //     }
        // });
        $loading.addClass('loading');

        if ($_debug) console.log("loader started completed");
        if (typeof f == "function") f();
    }

    if (state == "finish") {
        TweenLite.to('.loaderTransition', 0.5, {
            x: '-100%',
            force3D: true,
            onComplete: function () {
                TweenLite.set('.loaderTransition', { clearProps: "all" });
                $('.loaderTransition').removeClass('light');
            }
        });

        $loading.removeClass('loading');
        if ($_debug) console.log("loader completed");
        if (typeof f == "function") f();
    }

    $_loaderState = state;
};

function clearPagesAfterloading(delay) {

    var $currentPage = $(".page-main.page-current"),
        $nextContent = $(".page-main.page-next"); // can't be global

    $.doTimeout(delay, function () {
        if ($_debug) console.log("clearPagesAfterloading");

        $currentPage.remove();
        $nextContent.removeClass("page-next").addClass("page-current").removeAttr("aria-hidden");

        var $newCurrentPage = $(".page-main.page-current");
        $newCurrentPage.after('<div class="page-main page-next" aria-hidden="true"></div>');
        $newCurrentPage.attr("style", "");

        onStartPageWhenRefresh(1);
    });
}

function onStartPageWhenRefresh(byRefresh) {
    if ($_debug) console.log("onStartPageWhenRefresh");

    if (byRefresh == 1 && $pageloaderActive == 1) {
        $(window).scrollTop(0);
        $("html,body").scrollTop(0);

        setTimeout(function () {
            initScripts();
            customScripts();
        }, 850);
    } else {
        var delay = $('body').hasClass('home') ? 2500 : 0;

        setTimeout(function () {
            $('.page-wrapper').imagesLoaded({ background: true }, function () {
                $('.loader').fadeOut('fast');

                initScripts();
                customScripts();

                setTimeout(function () {
                    document.body.dispatchEvent(new Event('uncode_waypoints'));
                }, 1200);
            });
        }, delay);
    }

    $_body.removeClass("loading-page");
    globalAllowClick = 1;
}

function handleMetas(response, is_load) {
    if ($_debug) console.log("altera metatags");

    document.title = response.find('title')[0].innerText;

    for (var i = 0, len = newMetas.length; i < len; i++) {
        if ($(newMetas[i]).attr('content') != "") {
            $(newMetas[i]).attr('content', $(newMetas[i], response).attr('content'));
        } else if ($(newMetas[i]).attr('href') != "") {
            $(newMetas[i]).attr('href', $(newMetas[i], response).attr('href'));
        }
    }

    handleParams();

    url_old = window.location.href;

    if ($_forPopstate) {
        history.pushState({}, document.title, $current_page);
        window.history.replaceState('Object', document.title, $current_page);
    }

    if ($_gaActive && is_load == 0) {
        if (typeof ga != 'undefined') {
            var d = location.pathname;
            ga('set', { page: d, title: document.title });
            ga('send', 'pageview');
        }
    }

    $_forPopstate = 1;
}

function handleParams() {
    if ($_urlParams) {
        if ($_loaderState == "finish" && $('.mask').css('display') == "none") {
            clearInterval($_loaderTimeout);
            if ($_debug) console.log("handleParams: " + $_urlParams);

            if ($_urlParams.indexOf("&") > 0) {
                var all_params = $_urlParams.split("&");
                all_params.forEach(function (param) {
                    var paramSplited = param.split("=");
                    if (paramSplited[0] == "anchor") {
                        $('html').stop(true, true).animate({
                            scrollTop: $('#' + paramSplited[1]).offset().top
                        }, 1500, 'easeInOutExpo', function () { });
                    }
                });
            } else {
                var paramSplited = $_urlParams.split("=");
                if (paramSplited[0] == "anchor") {
                    $('html').stop(true, true).animate({
                        scrollTop: $('#' + paramSplited[1]).offset().top
                    }, 1500, 'easeInOutExpo', function () { });
                }
            }
        } else {
            clearInterval($_loaderTimeout);
            $_loaderTimeout = setInterval(function () {
                handleParams();
            }, 100);
        }
    }
}

function initRemote() {
    if ($_debug) console.log("initRemote");

    $_body.on("click", 'a[data-remote="true"]', function (event) {
        event.preventDefault();
        var $this = $(this);

        if ($_debug) console.log("remote link: " + $this.attr("href"));

        //HANDLE URL
        var ajaxUrl = $this.attr("href"),
            ajaxUrlParams = $this.attr("href");

        if ($this.attr("href").indexOf("?") > 0) {
            if ($_debug) console.log("found params on remote btn: " + $_urlParams);

            var ajaxUrlField = $this.attr("href").split("?");
            ajaxUrlParams = ajaxUrlField[0];
            $_urlParams = ajaxUrlField[1];
        } else {
            $_urlParams = "";
        }

        //if (ajaxUrl != $current_page) {
        if ($_debug) console.log("btn remote clicked");

        $('#menu-header-menu .active').removeClass('current active');
        if ($this.parents('#menu-header-menu').length > 0) {
            $this.parent().addClass('current active');
        }

        $current_page = ajaxUrlParams;

        if (!globalAllowClick) {
            if ($_debug) console.log("globalAllowClick is 0, exit");
            return false; // exit and have normal click
        } else {
            $_body.addClass("loading-page");

            loadPages(ajaxUrl, $this.attr("data-pageTrans"), $this);
            globalAllowClick = 0;
        }
        // } else {
        //     if ($_debug) {
        //         console.log($current_page + "!=" + ajaxUrlParams);
        //     }
        // }
    });
};
function lookForActive() {
    var path = document.location.href.substr(document.location.href.lastIndexOf('/') + 1);

    if (path) {
        if ($_debug) console.log("looking for active link: " + path);

        var $element = $('a[data-remote="true"][href*="' + path + '"]');

        if ($element.length > 0) {
            if ($_debug) console.log("found active");

            $current_page = $element.attr("href");

            if ($current_page.indexOf("?") > 0) {
                var ajaxUrlField = $current_page.split("?");
                $current_page = ajaxUrlField[0];
            }

            if ($element.parent('.menu-page').length > 0) {
                $element.parent('.menu-page').addClass('current');
            }
        }
    }
}


/***************** FUNCTIONS *****************/
function initScrollIndicator() {    
    if ($('#progress-bar').length==0) $('<div id="progress-bar"></div>').appendTo('body');
    var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var scrolled = (winScroll / height) * 100;
    document.getElementById("progress-bar").style.width = scrolled + "%";
}
function goTo(obj, center) {
    'use strict';

    if ($(obj).length > 0) {
        if (center == 1) {
            var elOffset = $(obj).offset().top;
            var elHeight = $(obj).height();
            var windowHeight = $(window).height();
            var offset;

            var cenas = (windowHeight / 2);
            var cenas2 = (elHeight / 2);

            if (elHeight < windowHeight) {
                offset = elOffset - (cenas - cenas2);
            }

            $('html, body').stop(true, true).animate({
                scrollTop: offset
            }, 1500, '', function () { });
        } else {
            var offset = $(obj).offset().top;
            $('html, body').stop(true, true).animate({
                scrollTop: offset
            }, 1500, '', function () { });
        }
    }
}
function debounce(fn, threshold) {
    var timeout;
    threshold = threshold || 100;
    return function debounced() {
        clearTimeout(timeout);
        var args = arguments;
        var _this = this;
        function delayed() {
            fn.apply(_this, args);
        }
        timeout = setTimeout(delayed, threshold);
    };
}
function init_shares() {
    'use strict';

    if ($('.share-icon').length > 0) {
        $('.share-icon').click(function () {
            if ($(this).attr('data-link')) {
                window.open($(this).attr('data-link'), 'targetWindow', 'toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=no, width=500 ,height=400');
            }
        });
    }
}
function initIframes(){
    'use strict';
    if ($('.video_frame').length > 0) {
        $('.video_frame').each(function (index, element) {
			var vid = $(this).attr('data-vid');
			
			if(vid && !$(element).hasClass('framed')){
				if(vid.indexOf("/") !== -1){
					vid = vid.split('/');
					vid = vid[vid.length-1];
					if(vid.indexOf("?") !== -1){
						vid = vid.split('?');
						vid = vid[0];
					}
				}

                var embed; 
                var div = document.createElement("div");
                div.setAttribute("data-vid", vid);
                div.classList.add('has_bg');


				if($(element).hasClass('youtube')){
					var thumb = "hqdefault";
					embed = "https://www.youtube.com/embed/"+vid+"?autoplay=1";
                    
                    if ($(element).attr('data-coverimg') == ""){
                        if($(element).hasClass('full')){
                            thumb = "maxresdefault";
                        }
                        

                        if($(element).parents('[data-thumb]').length>0){
                            $(element).parents('[data-thumb]').attr('data-thumb', 'https://i.ytimg.com/vi/'+vid+'/default.jpg');
                        }
                        
                        thumb = "https://i.ytimg.com/vi/"+vid+"/"+thumb+".jpg";
                    }else{
                        thumb = $(element).attr('data-coverimg');
                    }
					
                    div.style.backgroundImage = "url('" + thumb + "')";
				}else if($(element).hasClass('vimeo')){
					embed = "https://player.vimeo.com/video/"+vid+"?autoplay=1";
                    var thumb;

                    if ($(element).attr('data-coverimg') == "") {
                        $.getJSON('http://www.vimeo.com/api/v2/video/' + vid + '.json?callback=?', { format: "json" }, function (data) {
                            thumb = data[0].thumbnail_large;
                            
                            if($(element).hasClass('full')){
                                var thumbSplit = thumb.split(/\d{3}(?=.jpg)/);
                                thumb = thumbSplit[0] + '1920x1080' + thumbSplit[1];
                            }

                            if($(element).parents('[data-thumb]').length>0){
                                $(element).parents('[data-thumb]').attr('data-thumb', thumbSplit[0] + '100x100' + thumbSplit[1]);
                            }
                        });
                    } else {
                        thumb = $(element).attr('data-coverimg');
                    }

                    div.style.backgroundImage = "url('" + thumb + "')";
				}
				
				
                $(div).html('<div class="play"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="314.068px" height="314.068px" viewBox="0 0 314.068 314.068" style="enable-background:new 0 0 314.068 314.068;" xml:space="preserve"><g><g id="_x33_56._Play"><g><path d="M293.002,78.53C249.646,3.435,153.618-22.296,78.529,21.068C3.434,64.418-22.298,160.442,21.066,235.534c43.35,75.095,139.375,100.83,214.465,57.47C310.627,249.639,336.371,153.62,293.002,78.53z M219.834,265.801c-60.067,34.692-136.894,14.106-171.576-45.973C13.568,159.761,34.161,82.935,94.23,48.26c60.071-34.69,136.894-14.106,171.578,45.971C300.493,154.307,279.906,231.117,219.834,265.801z M213.555,150.652l-82.214-47.949c-7.492-4.374-13.535-0.877-13.493,7.789l0.421,95.174c0.038,8.664,6.155,12.191,13.669,7.851l81.585-47.103C221.029,162.082,221.045,155.026,213.555,150.652z"/></g></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>');
				
				$(div).click(function() {
					var iframe = document.createElement("iframe");
					
					iframe.setAttribute("src", embed);
					iframe.setAttribute("frameborder", "0");
					iframe.setAttribute("allowfullscreen", "1");
					this.parentNode.replaceChild(iframe, this);
				});
	
				element.appendChild(div);
				$(element).addClass('framed');
			}
        });
	}
}


function init_fades() {
    'use strict';
    //Elements Fading
    if ($('.elements_animated').length > 0) {
        $('.elements_animated').each(function (index, element) {
            var watcher = scrollMonitor.create(element);

            watcher.enterViewport(function () {
                $(element).addClass('active');

                setTimeout(function () {
                    $(element).removeClass('elements_animated active');
                }, 1000);

                watcher.destroy();
            });
        });
    }
}

function init_inputs() {
    'use strict';

    if ($('.field_holder').length > 0) {
        $('.field_holder').each(function (index, element) {
            $("input, textarea", element).on("keypress focus", function () {
                if ($(this).val() !== '') {
                    $(this).parents('.field_holder').addClass('focused');
                } else {
                    $(this).parents('.field_holder').removeClass('focused');
                }
            });
            $("input, textarea", element).on("blur", function () {
                if ($(this).val() !== '') {
                    $(this).addClass('focused filled');
                } else {
                    $(this).removeClass('focused filled');
                }
            });
        });
    }
}


/*-------------------------------------------------------------------------------------------
=HANDLE MENU EFFECT - RUI
--------------------------------------------------------------------------------------------*/
function initMenuMobile() {
    if ($('nav#menu').length > 0) {
        $('.mobile-menu-trigger').on('click', function () {
            triggerMobileMenu();
        });

        if ($('nav#menu .has-sub').length > 0) {
            $(".has-sub > a").on("click", function () {
                if ($('nav#menu .has-sub.is-active').not($(this).parent()).length>0){
                    $('nav#menu .has-sub.is-active ul').slideUp('slow');
                    $('nav#menu .has-sub.is-active').removeClass('is-active');
                }
                $(this).parent().toggleClass('is-active');
                $(this).next('ul').slideToggle('slow');
            });
        }
        $('body').on('click', function (e) {
            'use strict';
            if ($(e.target).closest('.mobile-menu-trigger').length == 0 && $(e.target).closest('nav#menu').length == 0) {
                if ($('nav#menu').hasClass('menu-opened')) triggerMobileMenu();
            }
        });

    }

    if ($('.vmenu-container').length>0){
        $('.vmenu-container a.dropdown-toggle').on('click', function(e){
            e.preventDefault();
            $(this).next('ul').slideToggle('slow');
        });
        $('.mobile-menu-button').on('click', function(){
            $('body').toggleClass('overHidden-menu');
            
            setTimeout(function(){
                if($('body').hasClass('off-opened')){  
                    $('#main-logo svg').addClass('light');
                }else{
                    $('#main-logo svg').removeClass('light');
                }
                
                
                $('.vmenu-container').toggleClass('opened');
                $('.menu-side-content').toggleClass('opened');
                $('.menu-wrapper .navbar .menu-container').toggleClass('menu-opened');                    
            }, 300);
            
            if ($('body').innerWidth() > 960) {
                let allowTilt = true;
                let lineEq;
                let getMousePos;

                if($('body').hasClass('off-opened')){ 
                    setTimeout(function(){  
                        TweenLite.to('.menu-side-content .grid_item', 1, {
                            autoAlpha: 1,
                            y: 0,
                            ease: Power2.easeOut,
                        });
                        TweenLite.to('.menu-title', 1, {
                            opacity: 0.5,
                            ease: Power2.easeOut,
                        });
                    }, 800);

                    // from http://www.quirksmode.org/js/events_properties.html#position
                    getMousePos = (e) => {
                        let posx = 0;
                        let posy = 0;
                        if (!e) e = window.event;
                        if (e.pageX || e.pageY) 	{
                            posx = e.pageX;
                            posy = e.pageY;
                        }else if (e.clientX || e.clientY) 	{
                            posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
                            posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
                        }
                        return { x : posx, y : posy }
                    };

                    // Equation of a line (y = mx + b ).
                    lineEq = (y2, y1, x2, x1, currentVal) => {
                        const m = (y2 - y1) / (x2 - x1);
                        const b = y1 - m * x1;
                        return m * currentVal + b;
                    };                    
                    
                    window.addEventListener('mousemove', tiltGridMenu);
                } else {
                    TweenLite.to('.menu-side-content .grid_item', 1, {
                        autoAlpha: 0,
                        y: 0,
                        ease: Power2.easeOut,
                    });
                    TweenLite.to('.menu-title', 1, {
                        opacity: 0,
                        ease: Power2.easeOut,
                    });
                                        
                    window.removeEventListener('mousemove', debounce(tiltGridMenu));
                }

                function tiltGridMenu(ev) {
                    if (!allowTilt) return;
                    const mousepos = getMousePos(ev);
                    // Document scrolls.
                    const docScrolls = {
                        left: document.body.scrollLeft + document.documentElement.scrollLeft,
                        top: document.body.scrollTop + document.documentElement.scrollTop
                    };
                    // Mouse position relative to the main element.
                    const relmousepos = {
                        x: mousepos.x - docScrolls.left,
                        y: mousepos.y - docScrolls.top
                    };
                    // Movement settings for the tilt elements.
                    Array.from(document.querySelectorAll('.grid_item')).forEach((item) => {
                        var delta = Number(item.dataset.cty) + lineEq(item.dataset.maxTy, item.dataset.minTy, $(window).height(), 0, relmousepos.y);
                        TweenLite.to(item, 4, {
                            y: delta,
                            ease: Power2.easeOut,
                        });
                    });
                }
            }
        });
        $('body').on('click', function (e) {
            'use strict';
            if ($(e.target).closest('.menu-wrapper').length == 0) {
                if ($('body').hasClass('off-opened')){
                    $('.mobile-menu-button').trigger('click');
                    $('.mobile-menu-button').removeClass('closing');
                }
            }
        });
    }
}
function triggerMobileMenu() {
    if ($('nav#menu').length > 0) {
        $('body').toggleClass('overHidden');
        $('nav#menu').toggleClass('menu-opened');
    }
}   


/***************** PLUGINS *****************/
(function ($) { //$(window).scrolled(function() {	 Utilizar em vez de window on scroll, corre o codigo apenas quando o utilizar para o scroll
    'use strict';
    var uniqueCntr = 0;
    $.fn.scrolled = function (waitTime, fn) {
        if (typeof waitTime === "function") {
            fn = waitTime;
            waitTime = 200;
        }
        var tag = "scrollTimer" + uniqueCntr++;
        this.scroll(function () {
            var self = $(this);
            var timer = self.data(tag);
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(function () {
                self.removeData(tag);
                fn.call(self[0]);
            }, waitTime);
            self.data(tag, timer);
        });
    };
})(jQuery);

(function ($) { //$(window).resized(function() {	 Utilizar em vez de window on resize, corre o codigo apenas quando o utilizar para o resize
    'use strict';
    var uniqueCntr = 0;
    $.fn.resized = function (waitTime, fn) {
        if (typeof waitTime === "function") {
            fn = waitTime;
            waitTime = 200;
        }
        var tag = "resizeTimer" + uniqueCntr++;
        this.resize(function () {
            var self = $(this);
            var timer = self.data(tag);
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(function () {
                self.removeData(tag);
                fn.call(self[0]);
            }, waitTime);
            self.data(tag, timer);
        });
    };
})(jQuery);


/***************** INITS *****************/
document.addEventListener('DOMContentLoaded', function () {
    if ($pageloaderStarted == 0) {
        if ($_debug) console.log("doc ready");

        $pageloaderStarted = 1;
        onStartPageWhenRefresh(0);

        if ($pageloaderActive == 1) {

            $internalLinks.attr('data-remote', 'true');

            var params = document.location.href.substr(document.location.href.lastIndexOf('/') + 1);
            if (params.indexOf('?') > 0) {
                params = params.split('?');
                $_urlParams = params[1];
            }

            $('.navbar-main a[data-remote="true"]').on('click', function () {
                TweenLite.to('.menu-title', 1, {
                    opacity: 0,
                    ease: Power2.easeOut,
                });

                setTimeout(function(){
                    $('.mobile-menu-button').trigger('click');
                }, 750);
            })

            //** =INIT CLCKS
            initRemote();

            //** =LOOK FOR ACTIVE
            lookForActive();

            /*if ('serviceWorker' in navigator) {
                navigator.serviceWorker.register('service-worker.js');
            }*/

            // HISTORY
            if (window.addEventListener) {
                window.addEventListener("popstate", function (e) {// firefox vs webkit and safari trigers on
                    if ($_debug) console.log("entrou no popstate");
                    if (!$_html.hasClass("mobile")) {
                        if ($_debug) console.log(e);
                        if ($_debug) console.log(e.state + "||" + url_old + "!=" + window.location.href);
                        if (e.state || url_old != window.location.href) {
                            $_forPopstate = 0;
                            $.doTimeout(500, function () {
                                window.location = window.location;
                            });
                        } else {
                            $_forPopstate = 1;
                        }
                    }
                });//endif: does not excute for <= IE8
            }
        }
        /*-------------------------------------------------------------------------------------------
        =KEYS
        --------------------------------------------------------------------------------------------*/
        $(document).on("keydown", function (event) {
            switch (event.which) {
                case 40: //down
                    //return false;
                    break;
                case 38: //up
                    // return false;
                    break;
                case 13: // enter
                    //return false;
                    break;
                case 39: //next
                    // return false;
                    break;
                case 37: //prev
                    // return false;
                    break;
                case 27:

                    if ($('#menu-header-menu').length > 0 && $_body.hasClass('off-opened')) {
                        triggerMobileMenu();
                    }

                    return;
            }
        });
    }
});

$(document).ready(function () {
    var animation = new TimelineMax({
        repeat: -1
    });
    animation.to(".loader svg path", 0.5, {
        attr: { d: 'M 45.9 161.5 C 72.3 175.7 130.7 193.1 165.9 157.6 C 191.4 131.9 179.9 91.3 166.6 74 C 145.4 46.3 98.4 64.5 83.3 49.6 C 65.3 31.8 58.8 11.8 42.5 12.4 C 23.5 13.1 12.2 24.1 4.8 64.6 C 0.1 90.5 -2.6 135.4 45.9 161.5 Z' }
    }).to(".loader svg path", 0.5, {
        attr: { d: 'M 54.9 164.2 C 89.7 159.9 71.1 134.5 109.1 101.9 C 124.1 89 152.6 108.9 166.7 87.1 C 185.7 57.8 159.1 39.4 134.6 25.4 C 112.6 12.8 81.6 9.8 60.2 13.2 C 41.4 16.2 21.3 26.7 13.9 67.3 C 9.2 93.2 0.3 170.8 54.9 164.2 Z' }
    }).to(".loader svg path", 0.5, {
        attr: { d: 'M 54.9 158.3 C 89.7 154 107 174.4 144.9 141.9 C 159.9 129 152.6 103.1 166.7 81.3 C 185.7 52 159.1 33.6 134.6 19.6 C 112.6 7 88.3 29.5 66.9 32.9 C 48.1 35.9 21.3 20.9 13.9 61.4 C 9.2 87.3 0.3 165 54.9 158.3 Z' }
    }).to(".loader svg path", 0.5, {
        attr: { d: 'M 53.9 166.6 C 81.8 177.6 141.9 187.8 172.6 148.3 C 194.8 119.7 178.5 80.8 163.3 65.2 C 139 40.2 138.4 24.4 121.7 11.5 C 101.7 -4 69.4 -2.2 51.6 7.3 C 30.1 18.7 10.1 33.7 1.6 75.3 C -3.8 101.1 2.7 146.5 53.9 166.6 Z' }
    });

    $('.loader span').animate({
        Counter: 100
    }, {
        duration: 2000,
        easing: 'swing',
        step: function (now) {
            $('.loader span').text(Math.ceil(now) + "%");
        }
    });

    initMenuMobile();
});

function initScripts() {
    $_body.addClass('doc-ready');
    
    initIframes();
    init_fades();
    init_inputs();
    init_shares();

    setTimeout(function() {
        setCursorSettings();
    }, 800);

    TweenLite.killTweensOf('.loader svg path'), 
    
    $(window).scroll(function () {
        initScrollIndicator();
    });
}